export default __webpack_public_path__ + "static/media/ic10.59cbe188.gif";